<!--message: {{message|json}}-->

<template #componentContainer></template>
